import { BrowserRouter, Routes, Route } from "react-router-dom";

import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import TutorLayout from "./pages/tutor/TutorLayout";
import TutorDashboard from "./pages/tutor/TutorDashboard";
import TutorStudents from "./pages/tutor/TutorStudents";
import TutorAssignments from "./pages/tutor/TutorAssignments";
import TutorQuestionPage from "./pages/tutor/TutorQuestionPage";
import StudentDetailPage from "./pages/tutor/StudentDetailPage";
import TestLandingPage from "./pages/TestLandingPage";
import TestQuestionPage from "./pages/TestQuestionPage";
import DiagnosticQuestionPage from "./pages/DiagnosticQuestionPage";
import ReviewDiagnosticPage from "./pages/tutor/ReviewDiagnosticPage";
import StudentLayout from "./pages/student/StudentLayout";
import StudentDashboard from "./pages/student/StudentDashboard";
import StudentAnalyticsPage from "./pages/student/StudentAnalyticsPage";
import StudentOutputPage from "./pages/student/StudentOutputPage";

import ProtectedRoute from "./components/auth/ProtectedRoute";
import AuthRedirect from "./components/auth/AuthRedirect";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Root decides where you go */}
        <Route path="/" element={<AuthRedirect />} />

        {/* Public */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />

        {/* Tutor diagnostic review OUTSIDE TutorLayout */}
        <Route
          path="/tutor/diagnostics/:studentId/:attemptId/review"
          element={
            <ProtectedRoute role="tutor">
              <ReviewDiagnosticPage />
            </ProtectedRoute>
          }
        />

        {/* Tutor */}
        <Route
          path="/tutor"
          element={
            <ProtectedRoute role="tutor">
              <TutorLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<TutorDashboard />} />
          <Route path="dashboard" element={<TutorDashboard />} />
          <Route path="students" element={<TutorStudents />} />
          <Route path="students/:studentId" element={<StudentDetailPage />} />
          <Route path="assignments" element={<TutorAssignments />} />
        </Route>

        {/* Student */}
        <Route
          path="/student"
          element={
            <ProtectedRoute role="student">
              <StudentLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<StudentDashboard />} />
          <Route path="dashboard" element={<StudentDashboard />} />
          <Route path="analytics" element={<StudentAnalyticsPage />} />
          <Route path="output" element={<StudentOutputPage />} />
        </Route>
        <Route
          path="/test/:testId"
          element={
            <ProtectedRoute role="student">
              <TestLandingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/test/:testId/question"
          element={
            <ProtectedRoute role="student">
              <TestQuestionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/diagnostic/:diagnosticId"
          element={
            <ProtectedRoute role="student">
              <DiagnosticQuestionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tutor/assignments/:assignmentId/question"
          element={
            <ProtectedRoute role="tutor">
              <TutorQuestionPage />
            </ProtectedRoute>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<AuthRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
